class HeatmapController {
  constructor() {
    this.name = 'heatmap';
  }
}

export default HeatmapController;



// WEBPACK FOOTER //
// ./client/common/directives/heatmap/heatmap.controller.js